import { RouteObject } from 'react-router-dom';
import RequireAuth from '~/components/auth/RequireAuth';
import AddValuation from '~valuation/pages/AddValuation';
import MyValuations from '~valuation/pages/MyValuations';
import ValuationResults from '~valuation/pages/ValuationResults';
import Valuation from '~valuation/pages/ValuationLanding';
import { ValuationRoutesEnum } from '~/constants/enums/valuationEnums';

export const valuationRoutes: RouteObject[] = [
  { index: true, element: <Valuation /> },
  {
    path: ValuationRoutesEnum.MY_VALUATIONS,
    element: (
      <RequireAuth>
        <MyValuations />
      </RequireAuth>
    ),
  },
  {
    path: ValuationRoutesEnum.ADD,
    element: (
      <RequireAuth>
        <AddValuation />
      </RequireAuth>
    ),
  },
  {
    path: ':id',
    element: (
      <RequireAuth>
        <ValuationResults />
      </RequireAuth>
    ),
  },
];
